const getHref = (): string => window.location.href;

const getSearch = (): string => window.location.search;

const getHostname = (): string => window.location.hostname;

const assign = (url: string): void => {
  window.location.assign(url);
};

const replace = (url: string): void => {
  window.location.replace(url);
};

export { getHref, getSearch, getHostname, assign, replace };
